// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SYSTEM_COMPANY_POSITION_LIST_MODAL_CHANGE,
} from './constants';

export function companyPositionListModalChange(visible,type) {
  return {
    type: SYSTEM_COMPANY_POSITION_LIST_MODAL_CHANGE,
    data: {visible,type}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_COMPANY_POSITION_LIST_MODAL_CHANGE:
      return {
        ...state,
        companyPositionListModalType:action.data.type,
        companyPositionListModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/companyPositionListModalChange.js